<template>
  <ExamStart :path="'/continueEdu'" style="margin-top: -120px;"></ExamStart>
</template>

<script>
  import ExamStart from '@/page/modules/questionnaire/result'
  export default {
    components: { ExamStart },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/questionnaire/result.vue